import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';

const createStyles = (theme = {}) =>
  StyleSheet.create({
    container: {
      border: `1.5px solid ${theme.bordercolor || '#000000'}`,
      padding: 6,
      marginBottom: 0,
      backgroundColor: '#ffffff',
    },
    topRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: 2,
    },
    symbolCenter: {
      fontSize: 13,
      fontFamily: 'NotoSansTamil',
      fontWeight: 'bold',
      textAlign: 'center',
      flex: 1,
      marginLeft: 40,
    },
    cellRight: {
      fontSize: 9,
      fontFamily: 'NotoSansTamil',
      fontWeight: 'bold',
      textAlign: 'right',
    },
    mainRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginVertical: 2,
    },
    leftCol: {
      width: '20%',
      alignItems: 'center',
      justifyContent: 'center',
    },
    centerCol: {
      width: '60%',
      alignItems: 'center',
      justifyContent: 'center',
    },
    rightCol: {
      width: '20%',
      alignItems: 'center',
      justifyContent: 'center',
    },
    titleRow: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    titlePrimary: {
      fontSize: 22,
      fontWeight: 'bold',
      color: theme.primaryColor || '#1D4ED8',
      fontFamily: 'NotoSansTamil',
    },
    titleSecondary: {
      fontSize: 22,
      fontWeight: 'bold',
      color: theme.secondaryColor || '#EA580C',
      fontFamily: 'NotoSansTamil',
    },
    subtitle: {
      fontSize: 10,
      fontWeight: 'bold',
      color: '#000000',
      textAlign: 'center',
      marginTop: 2,
      fontFamily: 'NotoSansTamil',
      letterSpacing: 0.5,
    },
    location: {
      fontSize: 9,
      fontWeight: 'bold',
      color: '#000000',
      textAlign: 'center',
      marginTop: 1,
      fontFamily: 'NotoSansTamil',
    },
    badgeBox: {
      border: '1.5px solid #000000',
      borderRadius: 3,
      paddingHorizontal: 10,
      paddingVertical: 2,
      marginTop: 3,
    },
    badgeText: {
      fontSize: 10,
      fontWeight: 'bold',
      color: '#000000',
      textAlign: 'center',
      fontFamily: 'NotoSansTamil',
    },
    logoBox: {
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px dashed #3B82F6',
      borderRadius: 40,
      padding: 6,
      width: 55,
      height: 55,
    },
    logoSubtext: {
      fontSize: 7,
      fontWeight: 'bold',
      color: '#1D4ED8',
      textAlign: 'center',
      marginTop: 2,
    },
  });

const HeaderThemeOne = ({ company = {}, theme = {} }) => {
  const styles = createStyles(theme);

  const rawName = company.name || 'VIJAY CRACKERS';
  const nameParts = rawName.trim().split(' ');
  const firstWord = nameParts[0] || 'VIJAY';
  const restWords = nameParts.slice(1).join(' ') || (nameParts.length === 1 ? '' : 'CRACKERS');

  const phone = company.phone || '96773 76335';
  const whatsapp = company.whatsapp || '99436 45343';
  const tagline = company.tagline || 'WHOLESALE & RETAILS';
  const location = company.addressLine1 || 'SIVAKASI';
  const badgeTitle = theme.pricelistTitle || '// PRICELIST - 2026 //';

  return (
    <View style={styles.container}>
      {/* Top Cell Numbers */}
      <View style={styles.topRow}>
        <View style={{ flex: 1 }} />
        <View style={{ alignItems: 'flex-end' }}>
          <Text style={styles.cellRight}>Cell : {phone}</Text>
          {whatsapp ? <Text style={styles.cellRight}>{whatsapp}</Text> : null}
        </View>
      </View>

      {/* Main Header Row */}
      <View style={styles.mainRow}>
        {/* Left Emblem / Logo */}
        <View style={styles.leftCol}>
          {company.logo ? (
            <Image src={company.logo} style={{ width: 55, height: 55, objectFit: 'contain' }} />
          ) : (
            <View style={styles.logoBox}>
              <Text style={{ fontSize: 16, color: '#1D4ED8', fontWeight: 'bold' }}>🎆</Text>
              <Text style={styles.logoSubtext}>QUALITY</Text>
            </View>
          )}
        </View>

        {/* Center Company Title & Info */}
        <View style={styles.centerCol}>
          <View style={styles.titleRow}>
            <Text style={styles.titlePrimary}>{firstWord} </Text>
            {restWords ? <Text style={styles.titleSecondary}>{restWords}</Text> : null}
          </View>

          <Text style={styles.subtitle}>{tagline}</Text>
          <Text style={styles.location}>{location}</Text>

          <View style={styles.badgeBox}>
            <Text style={styles.badgeText}>{badgeTitle}</Text>
          </View>
        </View>

        {/* Right Festival Emblem / Custom Image */}
        <View style={styles.rightCol}>
          {company.rightImage ? (
            <Image src={company.rightImage} style={{ width: 55, height: 60, objectFit: 'contain' }} />
          ) : (
            <View style={[styles.logoBox, { borderColor: '#EA580C' }]}>
              <Text style={{ fontSize: 18, color: '#EA580C' }}>✨</Text>
              <Text style={[styles.logoSubtext, { color: '#EA580C' }]}>FESTIVAL</Text>
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default HeaderThemeOne;
